import React from 'react';
import { createSvgIcon } from '@mui/material';

const ClockIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.24"
      d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0001 3.33366C6.31818 3.33366 3.33341 6.31843 3.33341 10.0003C3.33341 13.6822 6.31818 16.667 10.0001 16.667C13.682 16.667 16.6667 13.6822 16.6667 10.0003C16.6667 6.31843 13.682 3.33366 10.0001 3.33366ZM1.66675 10.0003C1.66675 5.39795 5.39771 1.66699 10.0001 1.66699C14.6025 1.66699 18.3334 5.39795 18.3334 10.0003C18.3334 14.6027 14.6025 18.3337 10.0001 18.3337C5.39771 18.3337 1.66675 14.6027 1.66675 10.0003ZM10.0001 5.83366C10.4603 5.83366 10.8334 6.20676 10.8334 6.66699V9.48256C10.8334 9.59307 10.8773 9.69905 10.9555 9.77719L12.256 11.0777C12.5814 11.4032 12.5814 11.9308 12.256 12.2562C11.9306 12.5817 11.4029 12.5817 11.0775 12.2562L9.77694 10.9557C9.38624 10.565 9.16675 10.0351 9.16675 9.48256V6.66699C9.16675 6.20676 9.53984 5.83366 10.0001 5.83366Z"
      fill="currentColor"
    />
  </svg>,
  'ClockIcon',
);

export default ClockIcon;
